var r={ENTER:"Enter",ARROW_UP:"ArrowUp",ARROW_DOWN:"ArrowDown"};export{r as EVENT_KEYS};
//# sourceMappingURL=dropdown.constants.js.map
